<template>
	<el-dialog
		title="预警详情"
		:visible.sync="dialogVisible"
		width="40%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-dialog">
		<el-descriptions :column="2" border>
			<el-descriptions-item label="所属项目">
				{{ data.project }}
			</el-descriptions-item>
			<el-descriptions-item label="所属业务">
				{{ data.business }}
			</el-descriptions-item>
			<el-descriptions-item label="风险等级">
				<el-tag :type="getRiskType(data.riskLevel)" size="small">
					{{ data.riskLevel }}
				</el-tag>
			</el-descriptions-item>
			<el-descriptions-item label="触发场景">
				{{ data.triggerScene }}
			</el-descriptions-item>
			<el-descriptions-item label="触发用户">
				{{ data.triggerUser }}
			</el-descriptions-item>
			<el-descriptions-item label="预警时间">
				{{ data.warningTime }}
			</el-descriptions-item>
			<el-descriptions-item label="关联合同编号">
				{{ data.contractNo }}
			</el-descriptions-item>
			<el-descriptions-item label="状态">
				<el-tag :type="getStatusType(data.status)" size="small">
					{{ data.status }}
				</el-tag>
			</el-descriptions-item>
			<el-descriptions-item label="预警规则" :span="2">
				{{ data.rule }}
			</el-descriptions-item>
		</el-descriptions>
		<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini" style="margin-top: 20px">
			<el-row :gutter="20">
				<!-- 计提月份 -->
				<el-col :span="24">
					<el-form-item label="处理内容" prop="description">
						<el-input type="textarea" v-model="form.description" size="small" placeholder="请输入处理内容" :rows="4" />
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<!-- 按钮 -->
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		name: 'RiskPreventionDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
					});
				}
			},
		},
		data() {
			return {
				form: {
					description: '',
				},
				rules: {
					description: [{ required: true, message: '请输入处理内容', trigger: 'blur' }],
				},
			};
		},
		methods: {
			getRiskType(level) {
				const map = {
					严重: 'danger',
					紧急: 'warning',
					一般: 'info',
				};
				return map[level] || 'info';
			},
			getStatusType(status) {
				const map = {
					未读: 'info',
					已读: 'success',
					处理中: 'warning',
					已关闭: 'danger',
				};
				return map[status] || 'info';
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleSubmit() {
				this.$emit('update:dialogVisible', false);
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}
</style>
